import { combineReducers } from 'redux';
import customizer from './customizer/';
import * as auth from '../_auth/reduxAuth';
import navbar from './navbar/Index';
import usersSlice from '../features/admin-manager/adminManagerSlice';
import ordersSlice from '../features/orders/ordersSlice';
import productSlice from '../features/product/productSlice';
import organizationSlice from '../features/organization/organizationsSlice';
import adminProfileSlice from '../features/admin-profile/adminProfileSlice';
import campaignSlice from '../features/campaign/campaignSlice';
import affiliateSlice from '../features/affiliate/affiliateSlice';
import campaignProductSlice from '../features/campaignProduct/campaignProductSlice';
import comissionMerchantSlice from '../features/comissionMerchant/comissionMerchantSlice';
import merchantListSlice from '../features/merchant/merchantSlice';
import referralListSlice from '../features/comissionReferral/comissionReferralSlice';
import affiliateListSlice from '../features/comissionAffiliate/comissionAffiliateSlice';
import bonusAffiliateSlice from '../features/bonusAffiliate/bonusAffiliateSlice';
import bonusMerchantSlice from '../features/bonusMerchant/bonusMerchantSlice';
import bonusReferralSlice from '../features/bonusReferral/bonusReferralSlice';
import campaignContactSlice from '../features/contact/contactSlice';
import UserContactSlice from '../features/users/usersSlice';
import QuestionSlice from '../features/question/questionSlice';
import productLineSlice from '../features/product-line/productLineSlice';
import provinderSlice from '../features/provinder-manger/provinderSlice';
const rootReducer = combineReducers({
    customizer: customizer,
    auth: auth.reducer,
    navbar: navbar,
    users: usersSlice,
    orders: ordersSlice,
    product: productSlice,
    campaign: campaignSlice,
    campaignProduct: campaignProductSlice,
    affiliate: affiliateSlice,
    organization: organizationSlice,
    adminProfile: adminProfileSlice,
    merchant: merchantListSlice,
    comissionmerchant: comissionMerchantSlice,
    comissionreferral:referralListSlice,
    comissionaffiliate:affiliateListSlice,
    contactsulution:campaignContactSlice,
    productline: productLineSlice,
    provinder:provinderSlice,
    bonusaffiliate:bonusAffiliateSlice,
    bonusmerchant:bonusMerchantSlice,
    bonusreferral:bonusReferralSlice,
    contactsulution:campaignContactSlice,
    userslist:UserContactSlice,
    question:QuestionSlice
});

export default rootReducer;

// getAdminUserProfile

// import { getAdminUserProfile } from '../../../redux/features/admin-profile/adminProfileSlice';

// const dispatch = useDispatch()

// const mapDispatchToProps = (dispatch) => {
//     return {
//       getAdminUserProfile: () => {
//         dispatch(getAdminUserProfile());
//       },
//     }
// }
